// extracted by mini-css-extract-plugin
export default {"notices":"Notices_notices__qnWH+","notices_header":"Notices_notices_header__ndqw4","close":"Notices_close__f90MR","refresh":"Notices_refresh__btaIt"};